import React, { Component, Fragment } from "react";
import IntlMessages from "Util/IntlMessages";
import {
    Row,
    Card,
    Button,
    CardTitle,
    CardBody
} from "reactstrap";
import ReactSiemaCarousel from "Components/ReactSiema/ReactSiemaCarousel";
import {

    DoughnutShadow
} from "Components/Charts";
import { Colxx } from "Components/CustomBootstrap";
import CustomSelectInput from "Components/CustomSelectInput";
import API from '../../../api/index';
import CircularProgressbar from "react-circular-progressbar";
import "chartjs-plugin-datalabels";
import "react-circular-progressbar/dist/styles.css";
import Select from "react-select";
var classNames = require('classnames');
import {
    chartTooltip, centerTextPlugin
} from "Components/Charts";
import NumberFormat from 'react-number-format';
import { ThemeColors } from "Util/ThemeColors";
const colors = ThemeColors();
const BasicInfoOptions = [
    { label: "با اطلاعات پایه تکمیل شده", value: "YES", key: 0 },
    { label: "بدون اطلاعات پایه تکمیل شده", value: "NO", key: 0 },
    { label: "همه", value: "ALL", key: 0 },
];
export default class AnalyticsDashboard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            BasicInfoValue: BasicInfoOptions[0],
            DashboardData: false,
            DoughnutChardData: {
                plugins: [centerTextPlugin],
                legend: {
                    position: "bottom",
                    labels: {
                        padding: 30,
                        usePointStyle: true,
                        fontSize: 12,
                        fontFamily: "irsans_l"
                    }
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    title: {
                        display: false
                    },
                    cutoutPercentage: 70,
                    layout: {
                        padding: {
                            bottom: 20
                        }
                    },
                    fontFamily: "irsans_l",
                    tooltips: chartTooltip
                },
                data: {
                    labels: ["با اطلاعات پایه", "همه مشتری ها"],
                    datasets: [
                        {
                            label: "",
                            borderColor: [colors.themeColor1, colors.themeColor2],
                            backgroundColor: [colors.themeColor1, colors.themeColor2],
                            fontFamily: "irsans_l",
                            borderWidth: 2,
                            data: [15, 85]
                        }
                    ]
                }
            }
        };

        this.loadData = this.loadData.bind(this);
        this.loadData();
    }
    componentWillReceiveProps(nextProps) {
        // You don't have to do this check first, but it can help prevent an unneeded render
        if (nextProps.match.params.customerTagID !== this.props.match.params.customerTagID) {
            this.setState({ isLoading: true }, () => {
                this.loadData();
            });

        }
    }
    loadData() {
        API.crm.customer.dashboard({ CustomerTagID: this.props.match.params.customerTagID == undefined ? -1 : this.props.match.params.customerTagID })
            .then(data => {
                (data.RELOGIN) ? this.props.logoutUser(this.props.history) : 0;

                if (this.props.match.params.customerTagID !== undefined) {
                    var _DoughnutChardData = this.state.DoughnutChardData;
                    console.log(data.Dashboard.Count.AllCustomers,data.Dashboard.Count.BasicInfo["YES"].COUNT);
                    var _PercentConverted = Math.round(((data.Dashboard.Count.BasicInfo["YES"].COUNT * 100) / data.Dashboard.Count.AllCustomers) * 100) / 100;
                    _DoughnutChardData.data.datasets[0].data = [_PercentConverted, 100 - _PercentConverted];
                    this.setState({
                        DoughnutChardData: _DoughnutChardData
                    });
                }
                this.setState({
                    DashboardData: data.Dashboard,
                    isLoading: false
                });
            })
            .catch(error => { });
    }

    render() {
        return (
            false ?
                <div className="loading"></div>
                :
                <Fragment>
                    <Row>

                        <Colxx xl="12" >
                            <div className="icon-cards-row">
                                <ReactSiemaCarousel
                                    perPage={{ 4: 4 }}
                                    controls={false}
                                    loop={false}
                                >
                                    <div className="icon-row-item hasarrow hastlastarrow">
                                        <Card className="mb-4 lastarrow">
                                            <CardBody className="text-center">
                                                <i className="iconsminds-king-2" />
                                                <p className="card-text font-weight-semibold mb-0">
                                                    با چند سفارش موفق
                                                </p>
                                                {this.state.isLoading ?
                                                    <div className="loading loading-inline" style={{ display: "block", "marginLeft": "auto", marginRight: "auto", float: "unset" }}></div>
                                                    : <p className="lead text-center">

                                                        {<NumberFormat value={this.state.DashboardData.Count.BasicInfo[this.state.BasicInfoValue.value].MULTIPLE} displayType={'text'} thousandSeparator={true} renderText={(value, prop) => <span >{value}</span>} />}
                                                    </p>
                                                }
                                            </CardBody>
                                        </Card>
                                    </div>

                                    <div className="icon-row-item hasarrow">
                                        <Card className="mb-4 midarrow">
                                            <CardBody className="text-center">
                                                <i className="iconsminds-add-basket" />
                                                <p className="card-text font-weight-semibold mb-0">
                                                    با سفارش موفق
                                                </p>
                                                {this.state.isLoading ?
                                                    <div className="loading loading-inline" style={{ display: "block", "marginLeft": "auto", marginRight: "auto", float: "unset" }}></div>
                                                    :
                                                    <p className="lead text-center">
                                                        {<NumberFormat value={this.state.DashboardData.Count.BasicInfo[this.state.BasicInfoValue.value].SUCCESS} displayType={'text'} thousandSeparator={true} renderText={(value, prop) => <span >{value}</span>} />}
                                                    </p>
                                                }
                                            </CardBody>
                                        </Card>
                                    </div>
                                    <div className="icon-row-item hasarrow ">
                                        <Card className="mb-4 midarrow">
                                            <CardBody className="text-center">


                                                <Select
                                                    components={{ Input: CustomSelectInput }}
                                                    className={"react-select arrowcardselect"}
                                                    classNamePrefix="react-select"
                                                    isMulti={false}
                                                    name="form-field-name"
                                                    disabled={this.state.isSaving}
                                                    value={this.state.BasicInfoValue}
                                                    onChange={(e) => { this.setState({ BasicInfoValue: e }) }}
                                                    style={{ width: "100px", zIndex: "9" }}
                                                    options={BasicInfoOptions}
                                                />
                                                <p className="card-text font-weight-semibold mb-0">
                                                    وضعیت اطلاعات پایه
                                                </p>
                                                {this.state.isLoading ?
                                                    <div className="loading loading-inline" style={{ display: "block", "marginLeft": "auto", marginRight: "auto", float: "unset" }}></div>
                                                    :
                                                    <p className="lead text-center">
                                                        {<NumberFormat value={this.state.DashboardData.Count.BasicInfo[this.state.BasicInfoValue.value].COUNT} displayType={'text'} thousandSeparator={true} renderText={(value, prop) => <span >{value}</span>} />}
                                                    </p>
                                                }
                                            </CardBody>
                                        </Card>
                                    </div>
                                    <div className="icon-row-item hasarrow">
                                        <Card className="mb-4 firstarrow">
                                            <CardBody className="text-center">
                                                {this.props.match.params.customerTagID != undefined ?
                                                    <Colxx xl="12" style={{ marginBottom: "30px" }}>
                                                        <div onClick={(e) => { this.props.history.push("/app/crm/customer/"); }} className="breadcrumb-item">
                                                            <div className={"iconsminds-business-man-woman headingicon"} style={{ marginLeft: "50px" }} />
                                                            <span style={{ marginRight: "10px" }}> همه مشتری ها</span>
                                                        </div>
                                                        <span className="breadcrumb-arrow" style={{ marginLeft: "10px" }}>{" > "}</span>

                                                    </Colxx>
                                                    : <i className={"iconsminds-business-man-woman"} />
                                                }
                                                <p className="card-text font-weight-semibold mb-0">
                                                    {this.props.match.params.customerTagID == undefined ?
                                                        <span> همه مشتری ها </span>
                                                        :
                                                        <span> همه: {" "}
                                                            {this.state.DashboardData.CustomerTagName}
                                                        </span>
                                                    }

                                                </p>
                                                {this.state.isLoading ?
                                                    <div className="loading loading-inline" style={{ display: "block", "marginLeft": "auto", marginRight: "auto", float: "unset" }}></div>
                                                    :
                                                    <p className="lead text-center">
                                                        {<NumberFormat value={this.state.DashboardData.Count.AllCustomers} displayType={'text'} thousandSeparator={true} renderText={(value, prop) => <span >{value}</span>} />}
                                                    </p>
                                                }
                                            </CardBody>
                                        </Card>
                                    </div>


                                </ReactSiemaCarousel>
                            </div>
                        </Colxx>

                        <Colxx xl={8}>
                            <Card className="timeline-card " style={{ "backgroundColor": "transparent" }}>

                                <CardBody style={{ "backgroundColor": "rgba(0,0,0,0.03)" }}>
                                    <CardTitle>
                                        <div className={"iconsminds-data-center headingicon"} />
                                        گزارشات
                                    </CardTitle>
                                    <Row>
                                        <Colxx xxs="6" className={"mb-4"}>
                                            <Card className={"report-card"}>
                                                <CardBody className="text-center" onClick={(e) => { this.props.match.params.customerTagID != undefined ? this.props.history.push("/app/crm/customer/" + this.props.match.params.customerTagID + "/list") : this.props.history.push("/app/crm/customer/list") }}>
                                                    <i className="iconsminds-data-center" />
                                                    <p className="card-text font-weight-semibold mb-0">
                                                        گزارش عمومی
                                                        {" "}
                                                        {this.props.match.params.customerTagID != undefined ?
                                                            <span > :  <span style={{ textDecoration: "underline" }}>{this.state.DashboardData.CustomerTagName}</span>
                                                            </span>
                                                            :
                                                            <span>
                                                                همه مشتری ها
                                                            </span>
                                                        }{" "}
                                                    </p>
                                                </CardBody>
                                            </Card>
                                        </Colxx>
                                        <Colxx xxs="6" className={"mb-4"}>
                                            <Card className={"report-card"} onClick={(e) => { this.props.match.params.customerTagID != undefined ? this.props.history.push("/app/crm/customer/" + this.props.match.params.customerTagID + "/list/with-success") : this.props.history.push("/app/crm/customer/list/with-success") }}>
                                                <CardBody className="text-center">
                                                    <i className="iconsminds-data-center" />
                                                    <p className="card-text font-weight-semibold mb-0">
                                                        گزارش

                                                        {" "}
                                                        {this.props.match.params.customerTagID != undefined ?
                                                            <span > :  <span style={{ textDecoration: "underline" }}>{this.state.DashboardData.CustomerTagName}</span>
                                                            </span>
                                                            :
                                                            <span>
                                                                همه مشتری ها
                                                            </span>
                                                        }{" "}

                                                        با سفارش موفق
                                                    </p>
                                                </CardBody>
                                            </Card>
                                        </Colxx>
                                        <Colxx xxs="6" className={"mb-4"}>
                                            <Card className={"report-card"} onClick={(e) => { this.props.match.params.customerTagID != undefined ? this.props.history.push("/app/crm/customer/" + this.props.match.params.customerTagID + "/list/only-failed") : this.props.history.push("/app/crm/customer/list/only-failed") }}>
                                                <CardBody className="text-center">
                                                    <i className="iconsminds-data-center" />
                                                    <p className="card-text font-weight-semibold mb-0">
                                                        گزارش
                                                        {" "}
                                                        {this.props.match.params.customerTagID != undefined ?
                                                            <span > :  <span style={{ textDecoration: "underline" }}>{this.state.DashboardData.CustomerTagName}</span>
                                                            </span>
                                                            :
                                                            <span>
                                                                همه مشتری ها
                                                            </span>
                                                        }{" "}
                                                        فقط با سفارش  نا موفق
                                                    </p>
                                                </CardBody>
                                            </Card>
                                        </Colxx>
                                        <Colxx xxs="6" className={"mb-4"}>
                                            <Card className={"report-card"} onClick={(e) => { this.props.match.params.customerTagID != undefined ? this.props.history.push("/app/crm/customer/" + this.props.match.params.customerTagID + "/list/multi-success") : this.props.history.push("/app/crm/customer/list/multi-success") }}>
                                                <CardBody className="text-center">
                                                    <i className="iconsminds-data-center" />
                                                    <p className="card-text font-weight-semibold mb-0">
                                                        گزارش
                                                        {" "}
                                                        {this.props.match.params.customerTagID != undefined ?
                                                            <span > :  <span style={{ textDecoration: "underline" }}>{this.state.DashboardData.CustomerTagName}</span>
                                                            </span>
                                                            :
                                                            <span>
                                                                همه مشتری ها
                                                            </span>
                                                        }{" "}
                                                        با چند سفارش موفق
                                                    </p>
                                                </CardBody>
                                            </Card>
                                        </Colxx>

                                    </Row>
                                </CardBody>
                            </Card>
                        </Colxx>
                        {this.props.match.params.customerTagID == undefined ?
                            <Colxx xl={4}>
                                <Card className="timeline-card " style={{ "backgroundColor": "transparent" }}>

                                    <CardBody style={{ "backgroundColor": "rgba(0,0,0,0.03)" }}>
                                        <CardTitle>
                                            <div className={"iconsminds-tag headingicon"} />
                                            برچسب ها
                                        </CardTitle>
                                        {this.state.isLoading ?
                                            <div className="loading loading-inline" style={{ display: "block", "marginLeft": "auto", marginRight: "auto", float: "unset" }}></div>
                                            :
                                            <Row>
                                                {this.state.DashboardData.CustomerTags.map((value, index) => (
                                                    <Colxx xxs="12" className={"mb-4"} key={index}>
                                                        <Card className={"tag-card"}>
                                                            <CardBody className="text-center">
                                                                <i className="iconsminds-tag" />
                                                                <p className="card-text font-weight-semibold mb-0">
                                                                    {value.name}
                                                                </p>

                                                                <Button color="primary" className=" mb-2 btn-shadow tagaddbutton" onClick={(e) => { this.props.history.push("/app/crm/customer/add/" + value.id) }}>
                                                                    <i className="simple-icon-plus" />
                                                                </Button>
                                                                <Button color="primary" className=" mb-2 btn-shadow tagdashbutton" onClick={(e) => { this.props.history.push("/app/crm/customer/" + value.id) }}>
                                                                    <i className="iconsminds-pie-chart-3" />
                                                                </Button>
                                                            </CardBody>
                                                        </Card>
                                                    </Colxx>
                                                ))}

                                            </Row>
                                        }
                                    </CardBody>
                                </Card>
                            </Colxx>
                            : <Colxx xl={4}>
                                <Card >

                                    <CardBody>
                                        <div className="dashboard-donut-chart">
                                            <DoughnutShadow {...this.state.DoughnutChardData} />
                                        </div>
                                    </CardBody>
                                </Card>
                            </Colxx>}
                    </Row>
                </Fragment>
        );
    }
}
